import { Component, Inject, forwardRef } from '@angular/core';
import { BaseWidget, NgAisInstantSearch } from 'angular-instantsearch';
import { connectMenu } from 'instantsearch.js/es/connectors';

@Component({
  selector: 'ng-ais-menu-select',
  inputs: ['attribute', 'limit', 'defaultText'],
  template: `
  <select class="menu-select" (change)="state.refine($event.target.value)">
    <option ng-if="defaultText" [value]="null">
      {{defaultText}}
    </option>
    <option *ngFor="let item of state.items" [value]="item.value" [selected]="item.isRefined">
      {{item.label}}
    </option>
  </select>
`
})

export class MenuSelect extends BaseWidget {

  attribute: string;
  limit?: number | string;
  defaultText?: string;
  
  state: {
    items: { label: string; value: string }[];
    createURL: () => string;
    refine: (value: string) => void;
    canRefine: boolean;
    isShowingMore: boolean;
    toggleShowMore: () => void;
    canToggleShowMore: boolean;
  }

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchParent
  ) {
    super('MenuSelect');
  }

  public ngOnInit() {
    this.createWidget(connectMenu, { 
      attributeName: this.attribute, 
      limit: this.limit, 
      headerText:this.defaultText
    });
    super.ngOnInit();
  }
}


// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/modules/menuselect.module.ts